<div *ngIf="cartItems$ | async as cartItems" class="padding-md wrap">
  <ng-container *ngIf="cartItems.length > 0">
    <div class="scrollable">
      <div class="content">
        <div
          *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.DELIVERY"
          class="product-list"
        >
          <div
            *ngFor="let weekNumber of weeksNumbersInOrder$ | async"
            class="by-weeks"
          >
            <div class="week-header-container">
              <div class="week-header">
                {{
                  "@common.weeksByIndex." + (weekNumber | weekIndexByWeekNumber)
                    | translate
                }}
              </div>
              <div class="range">
                {{ cartService.getWeekSlotAsString(weekNumber) }}
              </div>
            </div>
            <div
              [@fadeInOut]
              class="by-days"
              *ngFor="
                let day of cartService.getDeliveryDaysOfWeek$(weekNumber)
                  | async
              "
            >
              <div class="header">
                <div class="day-name">
                  {{ "@common.days.full." + day | translate }}
                </div>
                <div class="timeslot">
                  {{ (deliveryLocation$ | async)?.workTime }}
                </div>
              </div>
              <div class="items">
                <app-cart-item
                  *ngFor="
                    let item of cartItems
                      | filterCartItemsByDay : day : weekNumber
                  "
                  [item]="item"
                  (itemRemoveClick)="onRemoveProduct(item)"
                  (increasedAmount)="onIncreaseAmount(item)"
                  (decreasedAmount)="onDecreaseAmount(item)"
                  [@fadeInOut]
                  [disabled]="(weekNumber | weekIndexByWeekNumber) === null"
                ></app-cart-item>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.IN_STORE"
          class="product-list product-list-in-store"
        >
          <app-cart-item
            *ngFor="let item of cartItems"
            [item]="item"
            (itemRemoveClick)="onRemoveProduct(item)"
            (increasedAmount)="onIncreaseAmount(item)"
            (decreasedAmount)="onDecreaseAmount(item)"
            [@fadeInOut]
          ></app-cart-item>
        </div>
        <hr class="" />

        <!-- <div class="promocode-container">
        <div class="search-icon"></div>
        <input
          type="text"
          class="input"
          placeholder="{{ '@pages.cart.promocode.placeholder' | translate }}"
        />
        <div class="apply-icon"></div>
      </div> -->

        <div class="price-details">
          <!-- <div class="item">
            <div class="title">
              {{ "@pages.cart.subtotal" | translate }}
            </div>
            <app-price-label
              [value]="(subtotal$ | async)! | appCurrency | async"
              [noIcon]="true"
            ></app-price-label>
          </div>
          <div
            *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.DELIVERY"
            class="item"
          >
            <div class="title">
              {{ "@pages.cart.shipping" | translate }}
            </div>
            <app-price-label
              [value]="(shippingPrice$ | async)! | appCurrency | async"
              [noIcon]="true"
            ></app-price-label>
          </div> -->
          <div class="item">
            <div class="title">
              {{ "@pages.cart.total" | translate }}
            </div>
            <app-price-label
              [value]="(total$ | async)! | appCurrency | async"
              [noIcon]="true"
            ></app-price-label>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <app-action-button
        (click)="onCheckoutClick()"
        [label]="'@pages.cart.actionBtn' | translate"
      ></app-action-button>
    </div>
  </ng-container>
  <ng-container *ngIf="cartItems.length === 0">
    <div class="empty-cart">
      <app-svg-icon class="icon" [name]="'cart'"></app-svg-icon>
      <div class="hint">
        {{ "@pages.cart.emptyCartHint" | translate }}
      </div>
    </div>
  </ng-container>
</div>
